<div class="admin-doc-container" #pdfViewContainer>
  <div
    class="entity-view-title"
    [ngbTooltip]="adminDoc?.title"
    tooltipClass="simple-tooltip"
    [overflowThreshold]="2"
    overflowTooltip
    [openDelay]="500"
  >
    {{ adminDoc?.title }}
  </div>
  <div class="d-flex">
    <div *ngIf="adminDoc" class="info-section" data-cy="admin-doc-view-info-section">
      <div class="d-flex justify-content-between pb-4">
        <app-saving-panel
          data-cy="save-panel-button"
          [document]="{
            id: adminDoc.id,
            type: type,
            title: adminDoc.title,
            snippet: adminDoc.snippet,
            bookmarkPaths: adminDoc.bookmarkPaths,
            matchStems: adminDoc.matchStems,
            projectUid: project.id,
          }"
          (bookmarkPathsUpdated)="bookmarkPathsUpdated(adminDoc.id, $event)"
        >
        </app-saving-panel>
        <div class="d-flex align-items-center gap-2">
          <app-export-panel
            [hidden]="isSharingPanelOpen"
            [document]="adminDoc"
            [documentMetaData]="documentMetaData"
            [routeParams]="adminDocRouteParams"
          >
          </app-export-panel>
          <app-share-panel
            data-cy="share-panel-button"
            class="sharing-panel"
            [document]="documentToBeShared"
            [withExportPanel]="true"
            (toggle)="sharingPanelChangeExpandedState($event)"
          />
        </div>
      </div>
      <app-metadata
        id="admin-doc-metadata-panel"
        [documentType]="'admin_doc'"
        [website]="adminDoc.website"
        [publicationDate]="adminDoc.publicationDate"
        [territories]="adminDoc.territories"
        [issuerKind]="adminDoc.source"
        [displayedPublicationType]="adminDoc.displayedPublicationType"
        [associatedEntitiesTemplate]="associatedPanel"
      />
      <!--Panel "associated with" displayed in case of a prefectoral doc. Only if at least one other document linked to it-->
      @if (
        adminDoc.publicationType.includes(TerritoryWatchProjectPublicationTypeEnum.ARRETE) && (project.totalDocumentsCount ?? 1) - 1 > 0
      ) {
        <app-associated-panel
          #associatedPanel
          id="associated-with-panel"
          class="d-flex position-relative w-100"
          [panelTitle]="project.title"
          [externalLinkSectionTitle]="
            'document.associated-to.ext-link-pref-text' | translate: { count: project.totalDocumentsCount ?? 1 - 1 }
          "
          [externalLinkUrl]="project.url"
        >
          <!--content projected inside second line of component-->
          <div class="font-14px d-flex">
            <div class="fst-italic color-basic-600">
              ({{ 'document.associated-to.updated-on' | translate }} {{ project.updatedAt | date: 'dd/MM/yyyy' }})
            </div>
          </div>
        </app-associated-panel>
      }
      <app-task-reminder [documentId]="adminDoc.id"></app-task-reminder>
      <references-panel
        [references]="contactsPromise"
        [ready]="ready"
        [selectable]="fromNewsletter"
        [context]="{ contentType: 'admin_doc', docId: adminDoc.id, digestResultsId }"
      >
        <ng-template references-placeholder>
          <div class="contacts-frame themed contacts-placeholder" data-cy="contacts-placeholder">
            <i class="ph-fill ph-users-three"></i>
            <div class="placeholder-text">
              {{ 'references.contacts.placeholder' | translate }}
            </div>
            <ex-button type="secondary" variant="raised" size="small" (click)="loadContacts()" class="mt-2" data-cy="contacts-ask">
              {{ 'references.contacts.ask-explain-ai' | translate }}
            </ex-button>
          </div>
        </ng-template>
        <ng-template references-custom-actions>
          @if ((contactsPromise | async)?.length) {
            <ex-button
              type="secondary"
              variant="raised"
              size="small"
              icon="arrow-clockwise"
              (click)="loadContacts()"
              [ngbTooltip]="'references.contacts.refresh' | translate"
              tooltipClass="simple-tooltip fit"
              placement="bottom"
              [openDelay]="500"
            />
          }
        </ng-template>
        <ng-template references-error>
          <div class="contacts-frame contacts-error" data-cy="contacts-error">
            <div>{{ 'common.error-encountered' | translate }}</div>
            <ex-button type="secondary" variant="raised" size="small" (click)="loadContacts()">
              {{ 'common.retry' | translate }}
            </ex-button>
          </div>
        </ng-template>
        <ng-template references-empty>
          <div class="contacts-frame contacts-error" data-cy="contacts-empty">
            <div>{{ 'references.contacts.no-result' | translate }}</div>
            <ex-button type="secondary" variant="raised" size="small" (click)="loadContacts()">
              {{ 'common.retry' | translate }}
            </ex-button>
          </div>
        </ng-template>
        <ng-template references-loading>
          <div class="contacts-frame themed contacts-loading">
            <mat-icon svgIcon="loader"></mat-icon>
            <div>{{ contactsLoadingMessage | translate }}</div>
          </div>
        </ng-template>
      </references-panel>
    </div>
    @if (adminDoc) {
      <div class="right-content position-relative">
        <div class="shadow-overlay">
          <div class="first-line w-100 position-relative"></div>
        </div>

        <app-admin-doc-pdf [adminDoc]="adminDoc" [pdfView]="pdfView" [time]="time"></app-admin-doc-pdf>
      </div>
    }
  </div>
</div>
